import React, { useState, useEffect } from 'react';
import Helpers from 'utils/helpers';
import useInput from 'hooks/input';
import './checkbox.css';

export default function CheckboxInput(props) {
  const { setInputRef, isInputValid } = useInput({ hasCustomError: props.isInvalid });

  const [checked, setChecked] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);

  const hasChildren = (React.Children.count(props.children) > 0);
  const hasLabel = (props.label && !Helpers.String.isEmpty(props.label)) ? true : false;
  const disabled = props.readOnly || props.readonly || props.disabled;

  useEffect(() => {
    setChecked(props.checked || false);
    setIndeterminate(props.indeterminate || false);
  }, [props.checked, props.indeterminate, props.label]);

  const handleChange = (event) => {
    setChecked(event.target.checked);
    setIndeterminate(false);
    if (props.onChange) {
      props.onChange(event);
    }
    if (props.onValueChange) {
      props.onValueChange(event.target.checked);
    }
  };

  const handleRef = (ref) => {
    if (ref) {
      ref.indeterminate = indeterminate
    }
    setInputRef(ref);
  };

  const getContainerClass = () => {
    let classNames = ['custom-checkbox-container', props.className];
    if (!Helpers.String.isEmpty(props.size)) {
      classNames.push(`custom-checkbox-container-${props.size}`);
    }
    if (Helpers.Object.exists(props.block)) {
      classNames.push('custom-checkbox-container-block');
    }
    if (!hasChildren && !hasLabel) {
      classNames.push('custom-checkbox-container-nolabel');
    }
    return Helpers.String.join(classNames);
  };

  const getClass = () => {
    let classNames = ['custom-checkbox'];
    if (props.variant) {
      classNames.push(`custom-checkbox-${props.variant}`);
    }
    else {
      classNames.push('custom-checkbox-app');
    }
    if (props.disabled) {
      classNames.push('disabled');
    }
    if (!isInputValid()) {
      classNames.push('invalid');
    }
    if (props.isInvalid && props.alwaysShowValidity) {
      classNames.push('is-invalid');
    }
    else if (props.isValid && props.alwaysShowValidity) {
      classNames.push('is-valid');
    }
    return Helpers.String.join(classNames);
  };

  return (
    <span className={getContainerClass()}>
      <label className={getClass()}>
        <input
          type='checkbox'
          className='custom-checkbox-input'
          checked={checked}
          onChange={handleChange}
          ref={handleRef}
          disabled={disabled}
        />
        <span className='custom-checkbox-checkmark'></span>
        {props.label && <span className='custom-checkbox-label'>{props.label}</span>}
        {props.children && <span className='custom-checkbox-label'>{props.children}</span>}
      </label>
    </span>
  );
}